module.exports = __webpack_public_path__ + "static/heypaul_title-d5054c85ea3eaa5f5832c50c2483d19e.png";